/* eslint-disable no-param-reassign */
import { PayloadAction } from '@reduxjs/toolkit';
import uniqBy from 'lodash/uniqBy';
import some from 'lodash/some';
import Group from '../../models/groups';
import Membership from '../../models/membership';
import { PermissionsState, PermissionsTabEnum } from '../permissions.slice';
import allElementsIn from '../../utils/all-elements-in';

export default function toggleAll(
  state: PermissionsState,
  action: PayloadAction<{ groups: Group[], members: Membership[], ownerRoles: string[]}>,
) {
  const { tab, selectedMembers, selectedGroups } = state;
  const { groups, members, ownerRoles } = action.payload;

  if (tab === PermissionsTabEnum.Members) {
    const selectedGroupMembersIds = selectedGroups.flatMap((group) => group.memberIds);
    const membersTabManagedMembers = members
      .filter((member) => ownerRoles
        .includes(member.roleName) || selectedGroupMembersIds
        .includes(member.id));

    if (allElementsIn(members, selectedMembers)) {
      state.selectedMembers = membersTabManagedMembers;
    } else {
      state.selectedMembers = uniqBy([...state.selectedMembers, ...members], 'id');
    }
  }

  if (tab === PermissionsTabEnum.Groups) {
    const groupMembersIds = groups.flatMap((group) => group.memberIds);
    const owners = members.filter((member) => ownerRoles.includes(member.roleName));
    const membersInGroups = members.filter((member) => groupMembersIds.includes(member.id));

    if (allElementsIn(groups, selectedGroups)) {
      state.selectedGroups = selectedGroups.filter((selectedGroup) => !some(groups, selectedGroup));
      state.selectedMembers = owners;
    } else {
      state.selectedGroups = uniqBy([...state.selectedGroups, ...groups], 'id');
      state.selectedMembers = uniqBy([...state.selectedMembers, ...membersInGroups], 'id');
    }
  }
}
